import { library } from "@fortawesome/fontawesome-svg-core";
import {} from "@fortawesome/free-brands-svg-icons";
import {
  faSquarePollVertical,
  faUsers,
  faTableColumns,
} from "@fortawesome/free-solid-svg-icons";

library.add(faSquarePollVertical, faUsers, faTableColumns);
